<template>
	<div>
		<item-search :content="message" :showToolTip="true">
			<el-input
				class="sky-select"
				:type="inputType"
				:value="selfData"
				:size="size"
				@change="change"
				@input="input"
				v-bind="$attrs"
				ref="input"
				:placeholder="placeholder"
				validate-event
				:style="[inputStyle]"
			>
				<template v-if="scope && scope.vSlot" :slot="scope.vSlot">{{ scope.slotProp }}</template>
			</el-input>
		</item-search>
	</div>
</template>
<script>
import formStore from '@/mixins/formStore.js';
import itemSearch from '@/components/iglobalwin/formComponents/SkySuffix.vue';
export default {
	name: 'sky-input',
	mixins: [formStore],
	props: {
		toolContent: String,
		placeholder: String,
		inputType: {
			type: String,
			value: 'text',
		},
		size: String,
		scope: {
			type: Object,
		},
		message: {
			type: String,
		},
		messageStyle: {
			type: Object,
		},
		inputStyle: {
			type: Object,
			default() {
				return {
					width: '65%',
				};
			},
		},
	},
	data() {
		return {
			val: '',
		};
	},
	components: { itemSearch },
	methods: {
		change(val) {
			this.selfData = val;
			!this.delay && this.setVal();
			this.$emit('change', val);
			this.scope && this.scope.change && this.scope.change(val);
		},
		input(val) {
			this.selfData = val;
		},
	},
};
</script>
<style scoped lang="scss"></style>
